import type { IAccountNotificationsFiles } from './AccountNotificationsFiles.interface';
import AccountNotificationsPreferences from './AccountNotificationsPreferences';

export default class AccountNotificationsFiles implements IAccountNotificationsFiles {
  newMyFile: AccountNotificationsPreferences;
  newMyFileCP: AccountNotificationsPreferences;
  newMyFilePP: AccountNotificationsPreferences;
  newFile: AccountNotificationsPreferences;
  newFileDealOwner: AccountNotificationsPreferences;
  newFileCP: AccountNotificationsPreferences;
  newFilePP: AccountNotificationsPreferences;

  static build = (data: IAccountNotificationsFiles) => new AccountNotificationsFiles(data);
  static blank = () => new AccountNotificationsFiles();

  /**
   * Constructor
   * @param {IAccountNotificationsFiles} data
   */
  constructor(data?: IAccountNotificationsFiles) {
    this.newMyFile = new AccountNotificationsPreferences(data?.newMyFile);
    this.newMyFileCP = new AccountNotificationsPreferences(data?.newMyFileCP);
    this.newMyFilePP = new AccountNotificationsPreferences(data?.newMyFilePP);
    this.newFile = new AccountNotificationsPreferences(data?.newFile);
    this.newFileDealOwner = new AccountNotificationsPreferences(data?.newFileDealOwner);
    this.newFileCP = new AccountNotificationsPreferences(data?.newFileCP);
    this.newFilePP = new AccountNotificationsPreferences(data?.newFilePP);
  }
}
